import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Home from './pages/Home/Home';
import ORA_Cancer from './pages/ORA_Cancer/ORA_Cancer';
import Download from './pages/Download/Download';
import PP_Cancer from './pages/PP_Cancer/PP_Cancer';
import ORA_Immune from './pages/ORA_Immune/ORA_Immune';
import PP_Immune from './pages/PP_Immune/PP_Immune';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <h1>There are no page</h1>,
    children: [
      { index: true, element: <Home /> },
      { path: 'home', element: <Home /> },
      { path: 'ORA', element: <ORA_Cancer /> },
      { path: 'ORA_immune', element: <ORA_Immune /> },
      { path: 'CP', element: <PP_Cancer /> },
      { path: 'CP_immune', element: <PP_Immune /> },
      { path: 'download', element: <Download /> },
    ]
  }
])

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();